export default __webpack_public_path__ + "static/media/computer_nav.862c8920.svg";